const reelSwiper = new Swiper('.reels-area-swipe', {
    slidesPerView: 2.2,
    spaceBetween: 10,
    freeMode: true,
    breakpoints: {
        640: {
            slidesPerView: 2.2,
            spaceBetween: 10,
        },
        768: {
            slidesPerView: 3.5,
            spaceBetween: 10,
        },
        1024: {
            slidesPerView: 5,
            spaceBetween: 10,
        },
    },
});